import { createAsyncThunk } from '@reduxjs/toolkit';
import { getQuests as getQuestsService } from './services';
import { QuestContentful } from 'models/QuestContentful';

const GET_QUESTS = 'GET_QUESTS';
export const getQuests = createAsyncThunk<
  QuestContentful[],
  string | undefined
>(GET_QUESTS, getQuestsService);
